/* tslint:disable */ export const globalLocales =
{
  "en": {
    "(at a cost)": "(at a cost)",
    "(consultant, freelance, part-time or on-demand)": "(consultant, freelance, part-time or on-demand)",
    "(outside Torre)": "(outside Torre)",
    "$days $dayWord and $hours $hourWord": "{days} {dayWord} and {hours} {hourWord}",
    "$hours $hourWord and $minutes $minuteWord": "{hours} {hourWord} and {minutes} {minuteWord}",
    "$locale": "English (en)",
    "$minutes $minuteWord": "{minutes} {minuteWord}",
    "$months $monthWord $days $dayWord": "{months} {monthWord} {days} {dayWord}",
    "1+ year": "1+ year",
    "10+ years": "10+ years",
    "2+ years": "2+ years",
    "3+ years": "3+ years",
    "404 Error - Page not found.": "404 Error - Page not found.",
    "5+ years": "5+ years",
    "55% of jobs are found via referrals. Torre makes it easy to share your post and get as many referrals as possible.": "55% of jobs are found via referrals. Torre makes it easy to share your post and get as many referrals as possible.",
    "A complete genome increases your chances of standing out": "A complete genome increases your chances of standing out",
    "A flexible": "A flexible",
    "A full-time employee": "A full-time employee",
    "A full-time team member or employee": "A full-time team member or employee",
    "A new way to find talent": "A new way to find talent",
    "About the organization(s) (optional)": "About the organization(s) (optional)",
    "About the organization(s)": "About the organization(s)",
    "About Torre:": "About Torre:",
    "Add more experiences": "Add more experiences",
    "Add more relevant experiences": "Add more relevant experiences",
    "Add new skill": "Add new skill",
    "Add this person": "Add this person",
    "Additional details (optional)": "Additional details (optional)",
    "Additional details": "Additional details",
    "Additional requirements (other than skills) (optional)": "Additional requirements (other than skills) (optional)",
    "Additional requirements (other than skills)": "Additional requirements (other than skills)",
    "Advise others": "Advise others",
    "Advising others": "Advising others",
    "Allow recruiters to find you based on your desired compensation": "Allow recruiters to find you based on your desired compensation",
    "Already hired another applicant": "Already hired another applicant",
    "An error occurred. Please try again." : "An error occurred. Please try again.",
    "An error occurred": "An error occurred",
    "An intern": "An intern",
    "and": "and",
    "Any": "Any",
    "API for developers": "API for developers",
    "Applicant decided to quit the process": "Applicant decided to quit the process",
    "Applicant didn't complete the test(s)": "Applicant didn't complete the test(s)",
    "Applicant didn't pass the test(s)": "Applicant didn't pass the test(s)",
    "Applicant didn't show up to the interview": "Applicant didn't show up to the interview",
    "Applicant didn't submit the test": "Applicant didn't submit the test",
    "Applicant is unresponsive": "Applicant is unresponsive",
    "Applicant rejected offer": "Applicant rejected offer",
    "Applicants": "Applicants",
    "April": "April",
    "August": "August",
    "Auto-triggered message removed successfully": "Auto-triggered message removed successfully",
    "Auto-triggered message saved successfully": "Auto-triggered message saved successfully",
    "Automatically filter applicant": "Automatically filter applicant",
    "BACK": "BACK",
    "Be easily found": "Be easily found",
    "beginner": "beginner",
    "novice": "beginner",
    "Bonus will be provided": "Bonus will be provided",
    "Bonuses": "Bonuses",
    "Cancel": "Cancel",
    "Candidates can see the details of the members they'll work with.": "Candidates can see the details of the members they'll work with.",
    "Candidates can see their potential team members": "Candidates can see their potential team members",
    "Candidates": "Candidates",
    "Career path (optional)": "Career path (optional)",
    "Career path": "Career path",
    "Challenges (optional)": "Challenges (optional)",
    "Challenges": "Challenges",
    "CHANGES DETECTED": "CHANGES DETECTED",
    "Checkboxes": "Checkboxes",
    "Claim or create a team/company genome": "Claim or create a team/company genome",
    "Closed": "Closed",
    "Commission(s) will be provided": "Commission(s) will be provided",
    "compensation": "compensation",
    "Compensation": "Compensation",
    "Complete your genome": "Complete your genome",
    "Consultant": "Consultant",
    "Contact us": "Contact us",
    "Contacted": "Contacted",
    "Continue": "Continue",
    "conversational" : "Conversational",
    "Cost of coworking space will be covered": "Cost of coworking space will be covered",
    "Crawl description (Torrex only) (optional)": "Crawl description (Torrex only) (optional)",
    "Crawl description": "Crawl description",
    "Cultural fit": "Cultural fit",
    "daily": "day",
    "day": "day | days",
    "day(s)": "day(s)",
    "days": "days",
    "December": "December",
    "development interests": "development interests",
    "Discarded": "Discarded",
    "Doesn't match the skills you would like to learn or further develop": "Doesn't match the skills you would like to learn or further develop",
    "Doesn't match your experience": "Doesn't match your experience",
    "Dont.miss.new.opportunities.from.entityNames.Signal.subject": "Don’t miss new job openings from {entityNames}. Signal {subject}",
    "Signaled": "Signaled",
    "Employment": "Employment",
    "Equipment will be provided": "Equipment will be provided",
    "Error deleting auto-triggered message": "Error deleting auto-triggered message",
    "Error saving auto-triggered message": "Error saving auto-triggered message",
    "Error saving": "Error saving",
    "Error updating language": "Error updating language",
    "Error updating signal notification type": "Error updating signal notification type",
    "expert": "expert",
    "February": "February",
    "Filter": "Filter",
    "Flexible": "Flexible",
    "For candidates:": "For candidates:",
    "For everyone:": "For everyone:",
    "For talent seekers:": "For talent seekers:",
    "Free distribution": "Free distribution",
    "Free visibility": "Free visibility",
    "Freelance gigs": "Freelance gigs",
    "Freelance": "Freelance",
    "Full-time and/or part-time employment ": "Full-time and/or part-time employment ",
    "Full-time employment": "Full-time employment",
    "Full-time": "Full-time",
    "fully-fluent" : "Native or fully fluent",
    "Get others to signal you that they're considering working with you": "Get others to signal you that they're considering working with you",
    "Get relevant job openings": "Get relevant job openings",
    "Get signaled": "Get signaled",
    "Get verified": "Get verified",
    "Go to homepage": "Go to homepage",
    "GO": "GO",
    "Health insurance": "Health insurance",
    "Help someone you know find candidates": "Help someone you know find candidates",
    "Help": "Help",
    "Hired": "Hired",
    "Hiring talent": "Hiring talent",
    "hour": "hour | hours",
    "hour(s)": "hour(s)",
    "hourly": "hour",
    "hours": "hours",
    "If the problem persists,": "If the problem persists,",
    "In-person periodic retreats": "In-person periodic retreats",
    "Incomplete genome": "Incomplete genome",
    "Incomplete professional genome": "Incomplete professional genome",
    "Information submitted is incomplete": "Information submitted is incomplete",
    "Internship": "Internship",
    "Internships": "Internships",
    "Interview": "Interview",
    "Interviewed": "Interviewed",
    "It must be a valid URL": "It must be a valid URL",
    "It's detailed": "It's detailed",
    "It's not detailed": "It's not detailed",
    "January": "January",
    "Jobs for you": "Jobs for you",
    "July": "July",
    "June": "June",
    "Just learn more about the applicant": "Just learn more about the applicant",
    "Lacks the required {levelType} ({level}) in {valueType}: {value}": "Lacks the required {levelType} ({level}) in {valueType}: {value}",
    "Language fluency": "Language fluency",
    "Language updated!": "Language updated!",
    "language(s)": "language(s)",
    "Language(s)": "Language(s)",
    "Learn more": "Learn more",
    "Let talent seekers know what opportunities you are open to, so that you can be easily found by them.": "Let talent seekers know what opportunities you are open to, so that you can be easily found by them.",
    "Location isn't a match": "Location isn't a match",
    "Location": "Location",
    "location(s)": "location(s)",
    "Main reason(s):": "Main reason(s):",
    "Manually invited (sourced)": "Manually invited (sourced)",
    "March": "March",
    "Matches the skills you would like to learn or further develop": "Matches the skills you would like to learn or further develop",
    "Matches your experience": "Matches your experience",
    "Maximize referrals": "Maximize referrals",
    "May": "May",
    "Meetings": "Meetings",
    "Mentor others": "Mentor others",
    "Mentoring others": "Mentoring others",
    "Menu": "Menu",
    "Messages": "Messages",
    "minute": "minute | minutes",
    "minute(s)": "minute(s)",
    "minutes": "minutes",
    "month": "month | months",
    "monthly": "month",
    "months": "months",
    "Move to Ruled out": "Move to Ruled out",
    "Multiple choice": "Multiple choice",
    "Mutual match": "Mutual match",
    "Mutual matches": "Mutual matches",
    "Name": "Name",
    "Networking": "Networking",
    "New applicants": "New applicants",
    "New applicants will show up here.": "New applicants will show up here.",
    "NEXT": "NEXT",
    "nice to have": "nice to have",
    "No match because of {allButLastFilters}, and {lastFilter}": "No match because of {allButLastFilters}, and {lastFilter}",
    "No match because of {filter}": "No match because of {filter}",
    "No match": "No match",
    "No results found": "No results found",
    "No ruling out reason provided": "No ruling out reason provided",
    "No spam": "No spam",
    "No": "No",
    "Not a cultural match/fit": "Not a cultural match/fit",
    "Not enough proficiency in the skill(s)": "Not enough proficiency in the skill(s)",
    "Not now": "Not now",
    "Notifications": "Notifications",
    "November": "November",
    "October": "October",
    "Offer": "Offer",
    "Office or Location based": "Office or Location based",
    "Office or location-based": "Office or location-based",
    "Only interested in jobs that disclose compensation details": "Only interested in jobs that disclose compensation details",
    "Oops!": "Oops!",
    "Open (video response)": "Open (video response)",
    "Open (written answer)": "Open (written answer)",
    "Open to unpaid internships": "Open to unpaid internships",
    "Open to: ": "Open to: ",
    "Open to": "Open to",
    "Open": "Open",
    "Opening soon": "Opening soon",
    "Optionally.signal.entityNames.to.notify.subject.you.may.consider.working.with.subject.in.future": "Optionally, signal {entityNames} to notify {subject} you may consider working with {subject} in future.",
    "or": "or",
    "Organization": "Organization",
    "organization(s) size": "organization(s) size",
    "Other stronger candidates": "Other stronger candidates",
    "Other": "Other",
    "Part-time employment": "Part-time employment",
    "Part-time": "Part-time",
    "Post a job": "Post a job",
    "Pre-applied": "Pre-applied",
    "Preferences": "Preferences",
    "Privacy policy": "Privacy policy",
    "proficient": "proficient",
    "Project name*": "Project name*",
    "project": "project",
    "proximity to the location": "proximity to the location",
    "proximity to the time zone": "proximity to the time zone",
    "Publish a job": "Publish a job",
    "Purpose of the internship*": "Purpose of the internship*",
    "Qualifies the applicant": "Qualifies the applicant",
    "RE-OPEN IT": "RE-OPEN IT",
    "reading" : "Reading",
    "Refresh": "Refresh",
    "Related organization": "Related organization",
    "Remote": "Remote",
    "Reports": "Reports",
    "Reputation matters": "Reputation matters",
    "Request features": "Request features",
    "Responsibilities (optional)": "Responsibilities (optional)",
    "Responsibilities": "Responsibilities",
    "Retracted applications": "Retracted applications",
    "Role": "Role",
    "Ruled out": "Ruled out",
    "Rules out the applicant": "Rules out the applicant",
    "Save": "Save",
    "Screening questions answers": "Screening questions answers",
    "Pre-screening questions answers": "Pre-screening questions answers",
    "Screening questions": "Screening questions",
    "Pre-screening questions": "Pre-screening questions",
    "Search jobs - infinitive": "Search jobs",
    "Search jobs by:": "Search jobs by:",
    "Search jobs": "Search jobs",
    "Search people and organizations by name, username, or email": "Search people and organizations by name, username, or email",
    "Search people by name:": "Search people by name:",
    "Search people by skill:": "Search people by skill:",
    "Search people by:": "Search people by:",
    "Search people or organizations by name:": "Search people or organizations by name:",
    "Search": "Search",
    "September": "September",
    "Set your preferences and be notified of relevant jobs, consulting gigs, speaking engagements, mentoring, and more.": "Set your preferences and be notified of relevant jobs, consulting gigs, speaking engagements, mentoring, and more.",
    "Share a job link that you found": "Share a job link that you found",
    "Short list": "Short list",
    "Shortlisted": "Shortlisted",
    "Sign in": "Sign in",
    "Sign out": "Sign out",
    "Signaled by me": "Signaled by me",
    "Signalers will receive it": "Signalers will receive it",
    "Skill or Role": "Skill or Role",
    "Skill proficiency": "Skill proficiency",
    "Skill": "Skill",
    "skills required": "skills required",
    "Skills required": "Skills required",
    "skills with potential to develop": "skills with potential to develop",
    "Some job titles you might be interested in*": "Some job titles you might be interested in*",
    "Sorry! An error occurred": "Sorry! An error occurred",
    "Sorry!": "Sorry!",
    "spain flag": "spain flag",
    "Stock grants (RSUs, etc.)": "Stock grants (RSUs, etc.)",
    "Stock options": "Stock options",
    "Suggested by Torre": "Suggested by Torre",
    "Suggested from Torre's database": "Suggested from Torre's database",
    "Suggested from your database": "Suggested from your database",
    "Suggested": "Suggested",
    "Talent seekers": "Talent seekers",
    "task": "task",
    "Team culture (optional)": "Team culture (optional)",
    "Team culture": "Team culture",
    "Team structure (optional)": "Team structure (optional)",
    "Team structure": "Team structure",
    "Team values": "Team values",
    "Terms of use": "Terms of use",
    "The applicant appears not to be {levelType} enough in {value} as required ({level})": "The applicant appears not to be {levelType} enough in {value} as required ({level})",
    "The expected compensation is outside the budget": "The expected compensation is outside the budget",
    "The higher the reputation of the team members associated with the opportunity, the better the opportunity's exposure.": "The higher the reputation of the team members associated with the opportunity, the better the opportunity's exposure.",
    "The job opening is closed.": "The job opening is closed.",
    "the language": "the language",
    "The more experiences you have that relate to this opportunity, the better your chances of success will be": "The more experiences you have that relate to this opportunity, the better your chances of success will be",
    "The organization(s)": "The organization(s)",
    "the skill": "the skill",
    "The team": "The team",
    "To receive new candidates from Torre’s network, match or rule out current applicants.": "To receive new candidates from Torre’s network, match or rule out current applicants.",
    "To-rrex, our mascot, made a mistake that ended up a in series of unfortunate events.": "To-rrex, our mascot, made a mistake that ended up a in series of unfortunate events.",
    "Torre | Let AI do the job hunting and recruitment for you": "Torre | Let AI do the job hunting and recruitment for you",
    "Torre automatically shows your opportunity to relevant candidates who have signaled you and your team.": "Torre automatically shows your opportunity to relevant candidates who have signaled you and your team.",
    "Torre connects professional opportunities with the best-matching talent.": "Torre connects professional opportunities with the best-matching talent.",
    "Torre will share your job opening with potential candidates depending on the reputation of your team.": "Torre will share your job opening with potential candidates depending on the reputation of your team.",
    "Torre's product roadmap": "Torre's product roadmap",
    "Type of gig": "Type of gig",
    "type of job": "type of job",
    "Types of gigs you might be interested in*": "Types of gigs you might be interested in*",
    "uk flag": "uk flag",
    "Undo": "Undo",
    "Unknown reason": "Unknown reason",
    "Update organization size": "Update organization size",
    "Use as a ranking factor": "Use as a ranking factor",
    "Useful to filter or learn about applicants": "Useful to filter or learn about applicants",
    "Useful to have a better grasp of the applicants": "Useful to have a better grasp of the applicants",
    "Useful to learn about applicants": "Useful to learn about applicants",
    "Useful to rank or automatically filter applicants": "Useful to rank or automatically filter applicants",
    "View samples": "View samples",
    "Visit the homepage": "Visit the homepage",
    "We can’t seem to find the page you’re looking for.": "We can’t seem to find the page you’re looking for.",
    "weekly": "week",
    "Why this opportunity exists (optional)": "Why this opportunity exists (optional)",
    "Why this opportunity exists": "Why this opportunity exists",
    "word": "word",
    "Work samples don't match the company's requirements": "Work samples don't match the company's requirements",
    "XLS or CSV": "XLS or CSV",
    "year": "year | years",
    "yearly": "year",
    "Years of experience overall": "Years of experience overall",
    "Years of experience per skill": "Years of experience per skill",
    "years": "years",
    "Yes": "Yes",
    "Yes/No": "Yes/No",
    "You control how frequently you want to get relevant opportunities to your inbox.": "You control how frequently you want to get relevant opportunities to your inbox.",
    "You": "You",
    "Your account": "Your account",
    "Your applications": "Your applications",
    "Your browser does not support HTML5 video tags": "Your browser does not support HTML5 video tags",
    "Your career pages:": "Your career pages:",
    "Your dashboard": "Your dashboard",
    "Your genome": "Your genome",
    "Your job openings": "Your job openings",
    "Your jobs": "Your jobs",
    "Your professional genome:": "Your professional genome:",
    "Your teams and companies:": "Your teams and companies:",
    "Your torre account": "Your torre account"
  },
  "es": {
    "(at a cost)": "(con un costo)",
    "(consultant, freelance, part-time or on-demand)": "(consultoría, freelance, medio tiempo o bajo demanda)",
    "(outside Torre)": "(fuera de Torre)",
    "$days $dayWord and $hours $hourWord": "{days} {dayWord} y {hours} {hourWord}",
    "$hours $hourWord and $minutes $minuteWord": "{hours} {hourWord} y {minutes} {minuteWord}",
    "$locale": "Español (es)",
    "$minutes $minuteWord": "{minutes} {minuteWord}",
    "$months $monthWord $days $dayWord": "{months} {monthWord} {days} {dayWord}",
    "1+ year": "+1 año",
    "10+ years": "+10 años",
    "2+ years": "+2 años",
    "3+ years": "+3 años",
    "404 Error - Page not found.": "Error 404 - Página no encontrada.",
    "5+ years": "+5 años",
    "55% of jobs are found via referrals. Torre makes it easy to share your post and get as many referrals as possible.": "El 55% de los trabajos se obtienen a través de referencias. Torre facilita que tu publicación se comparta y reciba tantos referidos como sea posible.",
    "A complete genome increases your chances of standing out": "Un genoma completo aumenta tus posibilidades de resaltar entre la multitud",
    "A flexible": "Un flexible",
    "A full-time employee": "Un empleado a tiempo completo",
    "A full-time team member or employee": "Empleado de tiempo completo",
    "A new way to find talent": "Una nueva forma de encontrar talento",
    "About the organization(s) (optional)": "Acerca de la organización(es) (opcional)",
    "About the organization(s)": "Acerca de la organización(es)",
    "About Torre:": "Sobre Torre:",
    "About us": "Nosotros",
    "Add more experiences": "Agrega más experiencias",
    "Add more relevant experiences": "Agrega más experiencias relevantes",
    "Add new skill": "Agrega una nueva habilidad",
    "Add this person": "Añade esta persona",
    "Additional details (optional)": "Detalles adicionales (opcional)",
    "Additional details": "Detalles adicionales",
    "Additional requirements (other than skills) (optional)": "Requerimientos adicionales (que no sean habilidades) (opcional)",
    "Additional requirements (other than skills)": "Requerimientos adicionales (que no sean habilidades)",
    "Advise others": "Asesorar a otros",
    "Advising others": "Asesorar a otros",
    "Allow recruiters to find you based on your desired compensation": "Permite a reclutadores encontrarte con base en la compensación que deseas",
    "Already hired another applicant": "Ya se contrató a otro(a) aplicante",
    "An error occurred. Please try again." : "Ocurrió un error. Por favor inténtalo de nuevo.",
    "An error occurred": "Ocurrió un error",
    "An intern": "Pasante / Practicante",
    "and": "y",
    "Any": "Cualquiera",
    "API for developers": "API para desarrolladores",
    "Applicant decided to quit the process": "El/la aplicante decidió no continuar en el proceso",
    "Applicant didn't complete the test(s)": "El/la aplicante no completó el(los) test(s)",
    "Applicant didn't pass the test(s)": "El/la aplicante no aprobó el(los) test(s)",
    "Applicant didn't show up to the interview": "El/la aplicante no asistió a la entrevista",
    "Applicant didn't submit the test": "El aplicante no presentó el test",
    "Applicant is unresponsive": "El/la aplicante dejó de responder",
    "Applicant rejected offer": "El/la aplicante rechazó la oferta",
    "Applicants": "Aplicantes",
    "April": "Abril",
    "August": "Agosto",
    "Auto-triggered message removed successfully": "Mensaje automático eliminado exitosamente",
    "Auto-triggered message saved successfully": "Mensaje automático guardado exitosamente",
    "Automatically filter applicant": "Filtrar candidatos automáticamente",
    "BACK": "ATRÁS",
    "Be easily found": "Haz que te encuentren fácilmente",
    "beginner": "principiante",
    "novice": "principiante",
    "Bonus will be provided": "Se proporcionarán bonos",
    "Bonuses": "Bonos",
    "Cancel": "Cancelar",
    "Candidates can see the details of the members they'll work with.": "Los candidatos pueden ver los detalles de los miembros del equipo con los que trabajarán.",
    "Candidates can see their potential team members": "Los candidatos pueden ver los miembros del equipo con los que potencialmente trabajarán",
    "Candidates": "Candidatos",
    "Career path (optional)": "Trayectoria profesional (opcional)",
    "Career path": "Trayectoria profesional",
    "Challenges (optional)": "Desafíos (opcional)",
    "Challenges": "Desafíos",
    "CHANGES DETECTED": "CAMBIOS DETECTADOS",
    "Checkboxes": "Casillas de verificación",
    "Claim or create a team/company genome": "Reclama o crea un genoma de equipo/compañía",
    "Closed": "Cerrado",
    "Commission(s) will be provided": "Se pagarán comisiones",
    "compensation": "el salario",
    "Compensation": "La compensación",
    "Complete your genome": "Completa tu genoma",
    "Consultant": "Consultor",
    "Contact us": "Contáctanos",
    "Contacted": "Contactados",
    "Continue": "Continuar",
    "conversational": "Conversacional",
    "Cost of coworking space will be covered": "Se cubrirá el costo de un espacio de coworking",
    "Crawl description (Torrex only) (optional)": "Descripción del crawl (Sólo para Torrex) (opcional)",
    "Crawl description": "Descripción del crawl",
    "Cultural fit": "Match cultural",
    "daily": "día",
    "day": "día | días",
    "day(s)": "día(s)",
    "days": "días",
    "December": "Diciembre",
    "development interests": "intereses de desarrollo",
    "Discarded": "Descartados",
    "Doesn't match the skills you would like to learn or further develop": "No es un match con las habilidades que te gustaría aprender o desarrollar",
    "Doesn't match your experience": "No es un match con tu experiencia",
    "Dont.miss.new.opportunities.from.entityNames.Signal.subject": "No te pierdas nuevas vacantes de {entityNames}. Envía un signal",
    "Signaled": "Signal enviado",
    "Employment": "Empleo",
    "Equipment will be provided": "Se proporcionará equipo",
    "Error deleting auto-triggered message": "Error al eliminar el mensaje automático",
    "Error saving auto-triggered message": "Error al guardar el mensaje automático",
    "Error saving": "Error guardando",
    "Error updating language": "Error actualizando idioma",
    "Error updating signal notification type": "Error actualizando tipo de notificación del signal",
    "expert": "experto",
    "February": "Febrero",
    "Filter": "Filtro",
    "Flexible": "Flexible",
    "For candidates:": "Para candidatos:",
    "For everyone:": "Para todos:",
    "For talent seekers:": "Para empleadores:",
    "Free distribution": "Distribución gratuita",
    "Free visibility": "Visibilidad gratuita",
    "Freelance gigs": "Trabajos temporales/freelance",
    "Freelance": "Freelance",
    "Full-time and/or part-time employment ": "Empleo de tiempo completo y/o medio tiempo",
    "Full-time employment": "Empleo a tiempo completo",
    "Full-time": "Tiempo completo",
    "fully-fluent": "Nativo o completamente fluido",
    "Get others to signal you that they're considering working with you": "Haz que otros te envíen Signals, para hacerte saber que considerarían trabajar contigo",
    "Get relevant job openings": "Consigue vacantes relevantes",
    "Get signaled": "Recibir signals",
    "Get verified": "Recibe verificaciones",
    "Go to homepage": "Ir a inicio",
    "GO": "CONTINUAR",
    "Health insurance": "Seguro de salud",
    "Help someone you know find candidates": "Ayuda a alguien que conoces a encontrar candidatos",
    "Help": "Ayuda",
    "Hired": "Contratados",
    "Hiring talent": "Contratar talento",
    "hour": "hora | horas",
    "hour(s)": "hora(s)",
    "hourly": "hora",
    "hours": "horas",
    "If the problem persists,": "Si el problema persiste,",
    "In-person periodic retreats": "Retiros periódicos en persona",
    "Incomplete genome": "Genoma incompleto",
    "Incomplete professional genome": "Genoma profesional incompleto",
    "Information submitted is incomplete": "La información enviada no está completa",
    "Internship": "Pasantía",
    "Internships": "Pasantías",
    "Interview": "Entrevista",
    "Interviewed": "Entrevistados",
    "It must be a valid URL": "Debe ser una URL válida",
    "It's detailed": "Es detallada",
    "It's not detailed": "No es detallada",
    "January": "Enero",
    "Jobs for you": "Trabajos",
    "July": "Julio",
    "June": "Junio",
    "Just learn more about the applicant": "Solo conocer un poco más sobre los candidatos",
    "Lacks the required {levelType} ({level}) in {valueType}: {value}": "No cuenta con el dominio requerido ({level}) en {valueType}: {value}",
    "Language fluency": "Dominio del idioma",
    "Language updated!": "¡Idioma actualizado!",
    "language(s)": "el idioma",
    "Language(s)": "Idioma(s)",
    "Learn more": "Conoce más",
    "Let talent seekers know what opportunities you are open to, so that you can be easily found by them.": "Permite a los buscadores de talento conocer que estás abierto a nuevas oportunidades, y así, ser fácilmente encontrado por ellos.",
    "Location isn't a match": "La ubicación no es un match",
    "Location": "Ubicación",
    "location(s)": "la ubicación",
    "Main reason(s):": "Motivo(s):",
    "Manually invited (sourced)": "Invitados manualmente",
    "March": "Marzo",
    "Matches the skills you would like to learn or further develop": "Es un match con las habilidades que te gustaría aprender o desarrollar",
    "Matches your experience": "Es un match con tu experiencia",
    "Maximize referrals": "Maximiza los referidos",
    "May": "Mayo",
    "Meetings": "Reuniones",
    "Mentor others": "Ser mentor",
    "Mentoring others": "Dar una mentoría",
    "Menu": "Menú",
    "Messages": "Mensajes",
    "minute": "minuto | minutos",
    "minute(s)": "minuto(s)",
    "minutes": "minutos",
    "month": "mes | meses",
    "monthly": "mes",
    "months": "meses",
    "Move to Ruled out": "Mover a Descartados",
    "Multiple choice": "Selección múltiple",
    "Mutual match": "Match mutuo",
    "Mutual matches": "Match mutuo",
    "Name": "Nombre",
    "Networking": "Generar redes 'networking'",
    "New applicants": "Nuevos aplicantes",
    "New applicants will show up here.": "Los nuevos aplicantes aparecerán aquí.",
    "NEXT": "SIGUIENTE",
    "nice to have": "ideal pero no requerido",
    "No match because of {allButLastFilters}, and {lastFilter}": "No es un match por {allButLastFilters}, y {lastFilter}",
    "No match because of {filter}": "No es un match por {filter}",
    "No match": "No es un match",
    "No results found": "No se encontraron resultados",
    "No ruling out reason provided": "No se especificó la razón de descarte",
    "No spam": "Sin spam",
    "No": "No",
    "Not a cultural match/fit": "El match cultural no es suficiente",
    "Not enough proficiency in the skill(s)": "La(s) habilidad(es) no tiene(n) el nivel de competencia suficiente",
    "Not now": "Ahora no",
    "Notifications": "Notificaciones",
    "November": "Noviembre",
    "October": "Octubre",
    "Offer": "Oferta",
    "Office or Location based": "En oficina o ubicación específica",
    "Office or location-based": "En una ubicación fija u oficina",
    "Only interested in jobs that disclose compensation details": "Solo tengo interés en empleos que publiquen los detalles de la compensación",
    "Oops!": "¡Ups!",
    "Open (video response)": "Abierta (respuesta en video)",
    "Open (written answer)": "Abierta (respuesta escrita)",
    "Open to unpaid internships": "Interés en pasantías sin pago",
    "Open to: ": "Abierto a: ",
    "Open to": "Abierto a",
    "Open": "Abierto",
    "Opening soon": "Abrirá próximamente",
    "Optionally.signal.entityNames.to.notify.subject.you.may.consider.working.with.subject.in.future": "Opcionalmente, envía un signal a {entityNames} para notificar que considerarías trabajar con él/ella/ellos en el futuro.",
    "or": "o",
    "Organization": "Organización",
    "organization(s) size": "el tamaño de la(s) organización(es)",
    "Other stronger candidates": "Existen mejores candidatos",
    "Other": "Otra",
    "Part-time employment": "Empleo a medio tiempo",
    "Part-time": "Medio tiempo",
    "Post a job": "Publica un trabajo",
    "Pre-applied": "Preaplicaciones",
    "Preferences": "Preferencias",
    "Privacy policy": "Política de privacidad",
    "proficient": "competente",
    "project": "proyecto",
    "proximity to the location": "la cercanía a la ubicación",
    "proximity to the time zone": "la cercanía a la zona horaria",
    "Publish a job": "Publica un trabajo",
    "Qualifies the applicant": "Clasifica al candidato",
    "RE-OPEN IT": "REABRIRLA",
    "reading": "Lectura",
    "Refresh": "Refrescar",
    "Related organization": "Organizaciones relacionadas",
    "Remote": "Remoto",
    "Reports": "Reportes",
    "Reputation matters": "La reputación importa",
    "Request features": "Solicita nuevas características",
    "Responsibilities (optional)": "Responsabilidades (opcional)",
    "Responsibilities": "Responsabilidades",
    "Retracted applications": "Aplicaciones retiradas",
    "Role": "Cargo",
    "Ruled out": "Descartados",
    "Rules out the applicant": "Descarta al candidato",
    "Save": "Guardar",
    "Screening questions answers": "Respuestas a preguntas de selección",
    "Pre-screening questions answers": "Respuestas a preguntas de pre-selección",
    "Screening questions": "Preguntas de selección",
    "Pre-screening questions": "Preguntas de pre-selección",
    "Search jobs - infinitive": "Buscar trabajos",
    "Search jobs by:": "Buscar trabajos por:",
    "Search jobs": "Busca trabajos",
    "Search people and organizations by name, username, or email": "Busca personas u organizaciones por nombre, correo electrónico o nombre de usuario",
    "Search people by name:": "Busca personas por nombre:",
    "Search people by skill:": "Busca personas por habilidad:",
    "Search people by:": "Buscar personas por:",
    "Search people or organizations by name:": "Busca personas u organizaciones por nombre:",
    "Search": "Buscar",
    "September": "Septiembre",
    "Set your preferences and be notified of relevant jobs, consulting gigs, speaking engagements, mentoring, and more.": "Configura tus preferencias y recibe notificaciones de empleos relevantes, trabajos cortos, charlas, mentoría y mucho más.",
    "Share a job link that you found": "Comparte un enlace al empleo que encontraste",
    "Short list": "Preseleccionados",
    "Shortlisted": "Preseleccionados",
    "Sign in": "Acceder",
    "Sign out": "Cerrar sesión",
    "Signaled by me": "Les he enviado signals",
    "Signalers will receive it": "Si te envían Signals la recibirán",
    "Skill or Role": "Habilidad o Cargo",
    "Skill proficiency": "Dominio de habilidad",
    "Skill": "Habilidad",
    "Skills required": "Habilidades requeridas",
    "skills required": "las habilidades requeridas",
    "skills with potential to develop": "habilidades con potencial para desarrollar",
    "Some job titles you might be interested in*": "Algunos de los títulos de ofertas laborales que podrían interesarte*",
    "Sorry! An error occurred": "¡Perdón! Ocurrió un error",
    "Sorry!": "¡Perdón!",
    "spain flag": "bandera españa",
    "Stock grants (RSUs, etc.)": "Concesión de acciones (RSUs, etc.)",
    "Stock options": "Opción de compra de acciones",
    "Suggested by Torre": "Sugeridos por Torre",
    "Suggested from Torre's database": "Sugerencias de la base de datos de Torre",
    "Suggested from your database": "Sugerencias de tu base de datos",
    "Suggested": "Sugeridos",
    "Talent seekers": "Empleadores",
    "task": "tarea",
    "Team culture (optional)": "Cultura organizacional (opcional)",
    "Team culture": "Cultura organizacional",
    "Team structure (optional)": "Estructura del equipo (opcional)",
    "Team structure": "Estructura del equipo",
    "Team values": "Valores del equipo",
    "Terms of use": "Términos de uso",
    "The applicant appears not to be {levelType} enough in {value} as required ({level})": "Parece que el/la candidato(a) no cuenta con el dominio suficiente en {value} para cumplir con el nivel requerido ({level})",
    "The expected compensation is outside the budget": "La compensación deseada excede el presupuesto",
    "The higher the reputation of the team members associated with the opportunity, the better the opportunity's exposure.": "Entre mejor sea la reputación de los miembros del equipo asociados a la oportunidad, mejor será la exposición de la misma.",
    "The job opening is closed.": "Esta vacante se encuentra cerrada.",
    "the language": "el idioma",
    "The more experiences you have that relate to this opportunity, the better your chances of success will be": "Entre más experiencias tengas relacionadas con esta oportunidad, mayor probabilidad de éxito tendrás",
    "The organization(s)": "La(s) organización(es)",
    "the skill": "la habilidad",
    "The team": "El equipo",
    "To receive new candidates from Torre’s network, match or rule out current applicants.": "Para recibir nuevos candidatos de la red de Torre, marca como match o descarta aplicantes.",
    "To-rrex, our mascot, made a mistake that ended up a in series of unfortunate events.": "To-rrex, nuestra mascota, cometió un error que llevó a una serie de eventos desafortunados.",
    "Torre | Let AI do the job hunting and recruitment for you": "Torre | Deja que la inteligencia artificial haga el reclutamiento y la búsqueda de trabajo por ti",
    "Torre automatically shows your opportunity to relevant candidates who have signaled you and your team.": "Torre muestra automáticamente tu oportunidad a candidatos relevantes que te han enviado signals a ti y a tu equipo.",
    "Torre connects professional opportunities with the best-matching talent.": "Torre conecta oportunidades profesionales con el talento más adecuado para el puesto.",
    "Torre will share your job opening with potential candidates depending on the reputation of your team.": "Torre compartirá tu publicación con candidatos potenciales dependiendo de la reputación de tu equipo.",
    "Torre's product roadmap": "El mapa de producto de Torre",
    "Type of gig": "Tipo de trabajos temporales/freelance",
    "type of job": "el tipo de trabajo",
    "Types of gigs you might be interested in*": "Tipos de trabajos temporales/freelance que podrían interesarte",
    "uk flag": "bandera reino unido",
    "Undo": "Deshacer",
    "Update organization size": "Actualizar el tamaño de la organización",
    "Use as a ranking factor": "Usar como factor de clasificación",
    "Useful to filter or learn about applicants": "Útil para filtrar o conocer sobre los candidatos",
    "Useful to have a better grasp of the applicants": "Útil para conocer mejor a los candidatos",
    "Useful to learn about applicants": "Útil para conocer sobre los candidatos",
    "Useful to rank or automatically filter applicants": "Útil para clasificar o filtrar candidatos automáticamente",
    "Unknown reason": "Razón desconocida",
    "View samples": "Ver ejemplos",
    "Visit the homepage": "Visita la página principal",
    "We can’t seem to find the page you’re looking for.": "No podemos encontrar la página que estás buscando.",
    "weekly": "semana",
    "Why this opportunity exists (optional)": "Por qué existe esta oportunidad (opcional)",
    "Why this opportunity exists": "Por qué existe esta oportunidad",
    "word": "palabra",
    "Work samples don't match the company's requirements": "Las muestras de trabajo no son un match para los requisitos de la compañía",
    "XLS or CSV": "XLS o CSV",
    "year": "año | años",
    "yearly": "año",
    "Years of experience overall": "Años de experiencia",
    "Years of experience per skill": "Años de experiencia por habilidad",
    "years": "años",
    "Yes": "Sí",
    "Yes/No": "Sí/No",
    "You control how frequently you want to get relevant opportunities to your inbox.": "Tú controlas la frecuencia con la que recibes oportunidades relevantes en tu bandeja de entrada.",
    "You": "Tú",
    "Your account": "Tu cuenta",
    "Your applications": "Tus aplicaciones",
    "Your browser does not support HTML5 video tags": "Tu navegador no soporta etiquetas de video HTML5",
    "Your career pages:": "Páginas de empleos:",
    "Your genome": "Tu genoma",
    "Your job openings": "Tus vacantes",
    "Your jobs": "Tus vacantes",
    "Your professional genome:": "Tu genoma profesional:",
    "Your teams and companies:": "Tus equipos y compañías:",
    "Your torre account": "Tu cuenta de Torre"
  }
};//!
